import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import { NavLink } from 'react-router-dom';

import { connect } from 'react-redux';
import add from '../../assets/svgs/add.svg';
import ClearWebsiteCache from './clearWebsiteCache/ClearWebsiteCache';
import { isWebsiteAdmin } from '../../infrastructure/helpers/roles';
import PublishChanges from './clearWebsiteCache/PublishChanges';

class AdminActions extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            has_unpublished_changes: false,
            yacht_id: props.yacht_id,
            lastSucessfulUpdate: props.lastSucessfulUpdate
        };

    }

  componentDidUpdate(prevProps) {
    
    if (prevProps.yacht_id !== this.props.yacht_id && this.props.yacht_id) {
        this.setState({yacht_id: this.props.yacht_id})
    }

    if (prevProps.lastSucessfulUpdate !== this.props.lastSucessfulUpdate && this.props.lastSucessfulUpdate) {
        this.setState({lastSucessfulUpdate: this.props.lastSucessfulUpdate})
    }
  }

    render() {

        const {yacht_id, lastSucessfulUpdate} = this.state;
        const yachtIdInUrl = window.location.pathname.includes(yacht_id);
        return (
            <div
                className={`${
                    this.props.classname ? this.props.classname : ''
                } extra-table-actions`}
            >
            {(isWebsiteAdmin(this.props.user_role) || this.props.user_publishes_content) && typeof this.state.yacht_id === 'number' && yachtIdInUrl && <PublishChanges yacht_id={yacht_id} lastSucessfulUpdate={lastSucessfulUpdate} />}
                <NavLink
                    className="btn btn-blue"
                    to="/yachts/create"
                    style={{
                        maxWidth: '101px',
                        minWidth: '100px',
                        height: '32px',
                        color: '#fff',
                        fontSize: '1.2rem'
                    }}
                >
                    <ReactSVG path={add} style={{ height: 12 }} />
                    Add Νew
                </NavLink>
            </div>
        );
    }
}


function mapStateToProps(state) {
    
    return {
        yacht_id: state.yachts.yacht.initYacht.id ?? state.yacht_presentation.yacht_id ?? state.yacht_locations.yacht_id,
        has_unpublished_changes: state.yachts.yacht.error?.has_unpublished_changes,
        lastSucessfulUpdate: state.yachts.yacht.lastSucessfulUpdate,
        user_publishes_content: state.user.publishes_content === 1
    };
}

export default connect(mapStateToProps)(AdminActions);
